import React, { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addStudentToProposal } from "../../actions/proposal";
import { closeModal } from "../../actions/ui";
import { images } from "../../constants";
import { itemStudentAdded } from "../../helper/ItemAdded";
import { getStudentByName } from "../../helper/StudentFilters";
import AlertPopUp from "../generalComponents/AlertPopUp";
import LoaderDots from "../generalComponents/LoaderDots";
import { useForm } from "../hooks/useForm";
import "./ProposalStudentSelect.scss";

const ProposalStudentSelect = () => {
  const [formValues, handleInputchange, reset] = useForm({
    searchText: "",
  });
  const [searching, setSearching] = useState(false);
  const [filtered, setFiltered] = useState([]);
  const { searchText } = formValues;

  const { students } = useSelector((state) => state.students);
  const { ui } = useSelector((state) => state.ui);
  const { studentselected } = useSelector((state) => state.proposals);
  const dispatch = useDispatch();
  const studentAdded = itemStudentAdded(students, studentselected);

  //Helpers

  const studentBynameFiltered = useMemo(
    () => getStudentByName(students, searchText),
    [searchText, students]
  );


  const handleSelectStudent = (student) => {
    const {
      name,
      middlename,
      lastname,
      _id,
      nationality,
      email,
      phone,
      status,
    } = student;
    const studentSelected = {
      studentId: _id,
      studentname: name,
      middlename,
      studentlastname: lastname,
      nationality: nationality,
      email: email,
      phone: phone,
      status: status,
    };

    dispatch(addStudentToProposal(studentSelected));
    dispatch(closeModal());
  };

  //HANDLERS
  const handleSearch = (e) => {
    e.preventDefault();

    if (searchText.trim() !== "") {
      setSearching(true);
    }


    if (studentBynameFiltered.length !== 0) {
      setFiltered(studentBynameFiltered);
    }
    if (studentBynameFiltered.length === 0) {
      setFiltered([]);
    }
  };

  const handleClear = () => {
    setFiltered([]);
    setSearching(false);
    reset();
  };

  if (students.length === 0) {
    return <LoaderDots />;
  }
  return (
    <div className="student-select">
      <div className="main__search-bar">
        <form onSubmit={handleSearch} className="main__search-bar--form">
          <input
            type="text"
            name="searchText"
            id=""
            value={searchText}
            onChange={handleInputchange}
            placeholder={`Search...`}
            autoComplete="on"
            className="main__search-bar--input tx__sb-gray"
          />
          <button type="submit">
            <img src={images.IconSearch} alt="icon search" />
          </button>
        </form>
        <div className="main__search-bar--bottom">
          {filtered.length !== 0 && (
            <button onClick={handleClear} className="tx__cl-gray">
              Clear All
            </button>
          )}
        </div>
      </div>

      <div>
        {searching ? (
          <div>
            {filtered.length !== 0 ? (
              <ul className="list-flex-justcenter">
                {filtered?.map((student) => (
                  <div key={student._id} className="student-select__item">
                    <div className="student-select__item--img">
                      <img src={images.IconProfileR} alt="" />
                    </div>
                    <div className="student-select__item--name">
                      <h2 className="title-gray-bold-16">{student.name}</h2>
                      <h2 className="paragraph-gray-reg-16">
                        {student.lastname}
                      </h2>
                    </div>
                    <p
                      className={`student-select__item--status ${
                        student.status === "Onshore"
                          ? "isOnShore"
                          : "isOffShore"
                      }`}
                    >
                      {student.status}
                    </p>

                    {studentAdded.includes(student._id) ? (
                      <button className="btn-disable">added</button>
                    ) : (
                      <button
                        className="btn-primary"
                        onClick={() => handleSelectStudent(student)}
                      >
                        + add
                      </button>
                    )}
                  </div>
                ))}
              </ul>
            ) : (
              <div className="studentMain__alert">
                <div className="studentMain__alert--wrapper">
                  <AlertPopUp msg={`Search not found`} type={400} />
                  <button className="btn-primary" onClick={handleClear}>
                    Continue
                  </button>
                </div>
              </div>
            )}
          </div>
        ) : (
          <div>
            {students.length !== 0 ? (
              <>
                <ul className="list-flex-justcenter">
                  {students?.map((student) => (
                    <div key={student._id} className="student-select__item">
                      <div className="student-select__item--img">
                        <img src={images.IconProfileR} alt="" />
                      </div>
                      <div className="student-select__item--name">
                        <h2 className="title-gray-bold-16">{student.name}</h2>
                        <h2 className="paragraph-gray-reg-16">
                          {student.lastname}
                        </h2>
                      </div>
                      <p
                        className={`student-select__item--status ${
                          student.status === "Onshore"
                            ? "isOnShore"
                            : "isOffShore"
                        }`}
                      >
                        {student.status}
                      </p>

                      {studentAdded.includes(student._id) ? (
                        <button className="btn-disable">added</button>
                      ) : (
                        <button
                          className="btn-primary"
                          onClick={() => handleSelectStudent(student)}
                        >
                          + add
                        </button>
                      )}
                    </div>
                  ))}
                </ul>
              </>
            ) : (
              <div>
                {ui.loading ? (
                  <LoaderDots />
                ) : (
                  <AlertPopUp msg={"Students not Found"} type={400} />
                )}
              </div>
            )}
          </div>
        )}
      </div>

      {/* <ul className="student-select__list-container">
        {students?.map((student) => (
          <div key={student._id} className="student-select__item">
            <div className="student-select__item--img">
              <img src={images.IconProfileR} alt="" />
            </div>
            <div className="student-select__item--name">
              <h2 className="title-gray-bold-16">{student.name}</h2>
              <h2 className="paragraph-gray-reg-16">{student.lastname}</h2>
            </div>
            <p
              className={`student-select__item--status ${
                student.status === "Onshore" ? "isOnShore" : "isOffShore"
              }`}
            >
              {student.status}
            </p>

            {studentAdded.includes(student._id) ? (
              <button className="btn-disable">added</button>
            ) : (
              <button
                className="btn-primary"
                onClick={() => handleSelectStudent(student)}
              >
                + add
              </button>
            )}
          </div>
        ))}
      </ul> */}
    </div>
  );
};

export default ProposalStudentSelect;
